export const CREATE_CUSTOMER_SUCCESSFUL = 'CREATE_CUSTOMER_SUCCESSFUL'
export const CREATE_CUSTOMER_FAILED = 'CREATE_CUSTOMER_FAILED'
export const UPDATE_CUSTOMER_SUCCESSFUL = 'UPDATE_CUSTOMER_SUCCESSFUL'
export const UPDATE_CUSTOMER_FAILED = 'UPDATE_CUSTOMER_FAILED'
export const DELETE_CUSTOMER_SUCCESSFUL = 'DELETE_CUSTOMER_SUCCESSFUL'
export const DELETE_CUSTOMER_FAILED = 'DELETE_CUSTOMER_FAILED'